import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { LogoMark } from "./Logo";
import { FIRM, NAV } from "../../data/firm";
import { SERVICES } from "../../data/services";

const Col = ({ title, children }) => (
  <div>
    <p className="font-mono-x text-xs uppercase tracking-[0.2em] text-[var(--brass-deep)] mb-5">{title}</p>
    <div className="flex flex-col gap-3 text-ink/75 text-sm">{children}</div>
  </div>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-paper-2 text-ink border-t border-ink/10 overflow-hidden">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 pt-24 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <LogoMark className="w-14 h-14" />
          <p className="mt-6 max-w-sm text-ink/70 leading-relaxed">
            {FIRM.type}. Compliance, regulatory advisory, audit and documentation for SEBI-regulated entities.
          </p>
          {FIRM.membership && <p className="mt-4 font-mono-x text-xs text-ink/60">{FIRM.membership}</p>}
        </div>
        <div className="md:col-span-2"><Col title="Firm">{NAV.map((n) => <Link key={n.to} to={n.to} className="hover:text-[var(--brass-deep)] transition-colors">{n.label}</Link>)}</Col></div>
        <div className="md:col-span-2"><Col title="Services">{SERVICES.map((s) => <Link key={s.slug} to={`/services/${s.slug}`} className="hover:text-[var(--brass-deep)] transition-colors">{s.title}</Link>)}</Col></div>
        <div className="md:col-span-3">
          <Col title="Reach us">
            <span data-testid="footer-address">{FIRM.address}</span>
            <a data-testid="footer-phone" href={`tel:${FIRM.phone.replace(/\s/g, "")}`} className="hover:text-[var(--brass-deep)] transition-colors">{FIRM.phone}</a>
            <a data-testid="footer-email" href={`mailto:${FIRM.email}`} className="hover:text-[var(--brass-deep)] transition-colors">{FIRM.email}</a>
            <Link to="/contact" className="inline-flex items-center gap-1 text-[var(--brass-deep)] hover:text-ink transition-colors">Send an enquiry <ArrowUpRight className="w-4 h-4" /></Link>
          </Col>
        </div>
      </div>
      <p aria-hidden="true" className="mt-20 text-center font-display font-extrabold leading-[0.85] tracking-[-0.04em] text-[7vw] text-ink/[0.05] select-none whitespace-nowrap">
        Jay Kular&nbsp;&amp;&nbsp;Associates
      </p>
      <div className="mt-6 pt-6 border-t border-ink/10 flex flex-col sm:flex-row gap-3 justify-between text-xs text-ink/60">
        <span>© 2026 {FIRM.name}. Proprietorship firm of {FIRM.proprietor}.</span>
      </div>
    </div>
  </footer>
);
